// class helper functions
const removeClass = (el, classname) => {
    el.className = el.className.replace(" " + classname, "");
    el.className = el.className.replace(classname, "");
}
const addClass = (el, classname) => {
    if (!hasClass(el, classname)) {
        el.className += " " + classname;
    }
}
const hasClass = (el, classname) => {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

// Find the first ancestor with a particular classname
const findAncestor = (el, cls) => {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
}

const toggleValueInHiddenInput = (hiddenInput, slug, checked) => {
    const values = hiddenInput.value.split(',');
    if (checked == 'true') {
        hiddenInput.value = !values.includes(slug) ? [...values, slug].filter(el => el != '').join(',') : hiddenInput.value;
    } else {
        hiddenInput.value = values.filter(el => el != slug).join(',');
    }
}

const submitFormOfTheOption = option => {
    const form = findAncestor(option, 'wp-block-search');
    if (form) {
        form.submit();
    }
}

// check hidden inputs for values. If they exist, remove the required attribute from search bar, include it if not
const toggleSearchInputRequiredAttr = () => {
    const hiddenInps = document.querySelectorAll('.taxonomy-combobox-wrapper .hiddenInput');
    const searchInputs = document.querySelectorAll('.wp-block-search__input');

    const taxSelected = [].some.call(hiddenInps, inp => inp.value.trim() != '');
    if (taxSelected) {
        [].forEach.call(searchInputs, inp => inp.removeAttribute('required'));
    } else {
        [].forEach.call(searchInputs, inp => inp.setAttribute('required', ''));
    }
}
// toggle whether an option is selected or not
const toggleOptionSelect = option => {

    // toggle the main option
    const checked = (option.getAttribute('aria-selected') == 'false').toString();
    option.setAttribute('aria-selected', checked);
    
    // check for children and parent within the listbox
    const wrapper = findAncestor(option, 'taxonomy-combobox-wrapper');
    const hiddenInput = wrapper.querySelector('.hiddenInput');
    const listbox = wrapper.querySelector('.listbox');
    const term_id = option.getAttribute('data-termid');
    const parent = option.getAttribute('data-parent') != 0 ? option.getAttribute('data-parent') : false;
    const parentTaxonomy = parent != false ? listbox.querySelector(`[data-termid="${parent}"]`) : false;

    // add/remove value from hidden input
    const slug = option.getAttribute('value');
    toggleValueInHiddenInput(hiddenInput, slug, checked);

    // recursive method for children toggle
    const toggleAllChildren = (checked, term_id) => {
        const childTaxonomies = listbox.querySelectorAll(`[data-parent="${term_id}"]`);
        [].forEach.call(childTaxonomies, tax => {
            tax.setAttribute('aria-selected', checked);

            const childSlug = tax.getAttribute('value');
            toggleValueInHiddenInput(hiddenInput, childSlug, checked);
            toggleSearchInputRequiredAttr();
            toggleAllChildren(checked, tax.getAttribute('data-termid'));
        });
    } 
    toggleAllChildren(checked, term_id);
    
    // check if all siblings are checked, and if so, check off parent
    const toggleAnyParents = (checked, parentTaxonomy) => {
        if (parentTaxonomy) {
            const parent = parentTaxonomy.getAttribute('data-termid');
            
            const allSiblings = listbox.querySelectorAll(`[data-parent="${parent}"]`);
            const allCheckedSiblings =  [].filter.call( allSiblings, tax => tax.getAttribute('aria-selected') == checked);
            const everySiblingChecked = allSiblings.length == allCheckedSiblings.length;

            if (everySiblingChecked) {
                parentsToggled = true;
                parentTaxonomy.setAttribute('aria-selected', checked); 

                const parentSlug = parentTaxonomy.getAttribute('value');
                toggleValueInHiddenInput(hiddenInput, parentSlug, checked);

                const grandparentTaxonomy = listbox.querySelector(`[data-termid="${parentTaxonomy.getAttribute('data-parent')}"]`);
                toggleSearchInputRequiredAttr();
                toggleAnyParents(checked, grandparentTaxonomy);
            } 
        }
    }
    toggleAnyParents(checked, parentTaxonomy);
    toggleSearchInputRequiredAttr();
    submitFormOfTheOption(option);

}

// handle scroll of selected combobox options
const scrollToEl = (el, parent) => {
    
    const elTop = el.offsetTop;
    const elHeight = el.offsetHeight;
    const parentTop = parent.scrollTop;
    const parentHeight = parent.offsetHeight;

    
    if (elTop < parentTop) {
        parent.scrollTop = elTop;
    } else if (elTop + elHeight > parentTop + parentHeight) {
        parent.scrollTop = elTop - parentHeight + elHeight;
    }
}

// make an option the active descendant
const makeOptionDescendant = option => {
    const wrapper = findAncestor(option, 'taxonomy-combobox-wrapper');
    const combobox = wrapper.querySelector('.taxonomy-combobox');
    const listbox =  wrapper.querySelector('.listbox');
    const oldDescendant = listbox.querySelector('.option-current');

    // remove any other descendant 
    if (oldDescendant) {
        removeClass(oldDescendant, 'option-current');
    }

    // make the passed option the descendant
    addClass(option, 'option-current');
    combobox.setAttribute('aria-activedescendant', option.id)
    combobox.setAttribute('aria-expanded', 'true');
    scrollToEl(option, listbox);
}

// close the passed combobox
const closeCombobox = combobox => {
    combobox.setAttribute('aria-expanded', 'false');
    combobox.setAttribute('aria-activedescendant', '');
}


/* Taxonomical Dropdown Script
 * This will redirect the user to either a PostType or Taxonomy archive page
 * when they select an option from the taxonomical dropdown.
 * */ 
window.addEventListener('DOMContentLoaded', () => {
    const taxDropdown = document.getElementById('taxDropdown');
    const taxComboboxes = document.querySelectorAll('.taxonomy-combobox-wrapper');
    const taxCheckboxes = document.querySelectorAll('.taxonomy-checkbox');

    if (taxDropdown) {

        // grab localized variables
        const {
            searchId,
            homeUrl,
            postType,
            taxonomy
        } = searchDetails;

        // tax dropdown behavior
        taxDropdown.addEventListener("change", e => {

            // grab any search terms
            const search = document.getElementById(searchId).value;

            // if first dropdown option is selected, perform a post type search
            if (e.target.selectedIndex == 0) {
                const postTypeUrl = search !== null && search.trim() !== '' ?
                    `${homeUrl}/${postType}/?s=${search.trim()}` :
                    `${homeUrl}/${postType}/`;
                location.href = postTypeUrl;
                return;
            }

            // otherwise, perform a taxonomy term archive search
            const target = e.target.options[e.target.selectedIndex].value;
            const taxTermUrl = search !== null && search.trim() !== '' ?
                `${homeUrl}/${taxonomy}/${target}/?s=${search.trim()}` :
                `${homeUrl}/${taxonomy}/${target}/`;
            location.href = taxTermUrl;
            return;
        });


        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        // if there is a search query, then set the focus to the input field
        if( params.s != undefined){
            document.querySelector('.wp-block-search__input').focus();
        }
    } else if (taxComboboxes.length != 0 || taxCheckboxes.length != 0) {

        toggleSearchInputRequiredAttr();

        let searchTerm = '';

        const handleSearch = (e, wrapper) => {

            const combobox = wrapper.querySelector('.taxonomy-combobox');
            let firstLetterCheck = false;

            if ((e.key.length == 1 && e.key !== ' ' && !e.altKey && !e.ctrlKey && !e.metaKey)) {
                if (searchTerm == e.key || searchTerm.length == 0){
                    firstLetterCheck = true;
                } 
                if (searchTerm != e.key) {
                    searchTerm += e.key;
                }
                combobox.setAttribute('aria-expanded', 'true');
            } else if (e.code == 'Backspace') {
                searchTerm = searchTerm.slice(0, searchTerm.length);
                combobox.setAttribute('aria-expanded', 'true');
            } else {
                searchTerm = '';
            }

            // grab every option in the wrapper
            const allOpts = wrapper.querySelectorAll('.taxonomy');

            // is length of search term is one?
            if (firstLetterCheck) {
                
                // if so, grab all options that match first char
                const filteredOpts = [].filter.call(allOpts, el => el.innerText.toLowerCase().charAt(0) == searchTerm);
                if (filteredOpts.length) {
                    // see if any filtered options have current option. Is so, pick the next one
                    const currentOpts = [].filter.call(filteredOpts, el => hasClass(el, 'option-current'));
                    
                    if (currentOpts.length) {

                        // find where current option is among the filtered
                        const curIndex = [].indexOf.call(filteredOpts, currentOpts[0]);
                        if (curIndex > -1 && curIndex + 1 < filteredOpts.length) {
                            makeOptionDescendant(filteredOpts[curIndex + 1]);
                        } else {
                            makeOptionDescendant(filteredOpts[0]);
                        }
                    } else {
                       makeOptionDescendant(filteredOpts[0]);
                    }
                }
            } else if (searchTerm.length > 1) {

                // if searchTerm length is greater than 1, filter by search term and pick first match
                const filteredOpts = [].filter.call(allOpts, el => {
                    const termToCheck = el.innerText.replace(/\s/g, '').toLowerCase().slice(0, searchTerm.length)
                    return searchTerm == termToCheck;
                });
                if (filteredOpts.length) {
                    makeOptionDescendant(filteredOpts[0]);
                }
            }

            // after half a second, clear the search term
            setTimeout(() => searchTerm = '', 500);
        }

        [].forEach.call(taxComboboxes, el => {
            const wrapper = el;
            const combobox = wrapper.querySelector('.taxonomy-combobox');
            const label = wrapper.querySelector('.taxonomy-label');
            const listbox = wrapper.querySelector('.listbox');
            const hiddenInput = wrapper.querySelector('.hiddenInput');

            const toggleComboboxOpen = () => {
                if ( combobox.getAttribute('aria-expanded') != 'true' ) {
                    combobox.setAttribute('aria-expanded', 'true');
                    const activeDescendant = listbox.querySelector('.option-current');
                    if (activeDescendant) {
                        combobox.setAttribute('aria-activedescendant', activeDescendant.id)
                    }
                } else {
                    closeCombobox(combobox);
                }
            }
            
            // when clicking the combobox or it's label, make sure it opens/closes
            combobox.addEventListener('click', toggleComboboxOpen);
            label.addEventListener('click', toggleComboboxOpen);

            // keyboard support on combobox
            combobox.addEventListener('keydown', e => {
                const allOptions = listbox.querySelectorAll('.taxonomy');
                const firstEl = allOptions[0];
                const lastEl = allOptions[allOptions.length - 1];
                const activeDescendant = listbox.querySelector('.option-current');
                const code = 'code' in e ? e.code : null;
                
                const isExpanded = combobox.getAttribute('aria-expanded') == 'true';
                
                switch (code) {
                    case 'ArrowDown':   
                        e.preventDefault();

                        // is the combobox closed?
                        if (!isExpanded) {

                            // if so, simply open the combobox
                            combobox.setAttribute('aria-expanded', 'true');

                        } else {

                            // if not, is there no active descendant?
                            if (activeDescendant == null) {

                                // if there's no active descendant, set it to the first el
                                makeOptionDescendant(firstEl);
                            } else if (activeDescendant.nextElementSibling !== null) {

                                // if active descendant and there's a next sibling, make sibling the current option
                                makeOptionDescendant(activeDescendant.nextElementSibling);
                            } 
                        } 
                        break;

                    case 'ArrowUp':
                        e.preventDefault();
                        if (e.altKey && isExpanded) {
                            closeCombobox(combobox);
                        } else if (activeDescendant == null) {

                            // if not yet open, put fake focus on first option
                            makeOptionDescendant(activeDescendant.previousElementSibling);

                        } else if (activeDescendant.previousElementSibling !== null) {
                            
                            // if active descendant and there's a previous sibling, make sibling the current option
                            makeOptionDescendant(activeDescendant.previousElementSibling);
                        } 
                        break;

                    case 'Enter':
                    case 'Space':
                        e.preventDefault();
                        // open if not yet open
                        combobox.setAttribute('aria-expanded', 'true');
                        if (activeDescendant !== null) {
                            toggleOptionSelect(activeDescendant);
                        }
                        break;

                    case 'Home':
                        e.preventDefault();
                        makeOptionDescendant(firstEl);
                        break;

                    case 'End':
                        e.preventDefault();
                        makeOptionDescendant(lastEl);
                        break;

                    case 'PageUp':
                        if (isExpanded) {
                            e.preventDefault()

                            // go up 10 or to first, whichever is possible
                            const pageUpIndex = activeDescendant != null 
                            ? [].indexOf.call(allOptions, activeDescendant)
                            : 0;

                            if (pageUpIndex > 10) {
                                makeOptionDescendant(allOptions[pageUpIndex - 10]);
                            } else {
                                makeOptionDescendant(firstEl);
                            }
                        }
                        
                        break;

                    case 'PageDown':
                        if (isExpanded) {
                            e.preventDefault()

                            // go down 10 or to last el, whichever is possible
                            const pageDownIndex = activeDescendant != null 
                                ? [].indexOf.call(allOptions, activeDescendant)
                                : 0;

                            if (pageDownIndex + 10 < allOptions.length ) {
                                makeOptionDescendant(allOptions[pageDownIndex + 10]);
                            } else {
                                makeOptionDescendant(lastEl);
                            }
                        }
                        break;

                    case 'Tab':
                        // if user tabs away, close the combobox
                        closeCombobox(combobox);
                        break;
                }
                // if user types a printable key, let's implement search functionality
                handleSearch(e, wrapper);
                
            })
        });

        // give click event to each taxonomy option
        const taxonomyOptions = document.querySelectorAll('.taxonomy-combobox-wrapper .taxonomy');
        [].forEach.call(taxonomyOptions, option => {
            option.addEventListener('click', () => toggleOptionSelect(option));
        })

        // when clicking off a combobox, close it
        document.addEventListener('click', e => {

            // if they click anywhere, clear out the searchterm (edgecase but yeah)
            searchTerm = '';

            // grab wrapper if el is the ancester of one
            const wrapper = findAncestor(e.target, 'taxonomy-combobox-wrapper');

            // is the clicked el part of a combobox wrapper?
            if (wrapper != null) {

                // if so, close all the other comboboxes
                e.stopPropagation();
                const currentCombobox = wrapper.querySelector('.taxonomy-combobox');
                [].forEach.call(taxComboboxes, el => {
                    const otherCombobox = el.querySelector('.taxonomy-combobox');
                    if (currentCombobox.id != otherCombobox.id) {
                        closeCombobox(otherCombobox);
                    }
                })
            } else {

                // if not, close all comboboxes 
                [].forEach.call(taxComboboxes, el => {
                    const combobox = el.querySelector('.taxonomy-combobox');
                    closeCombobox(combobox);
                })
            }
        })
    }

    // give all taxonomy checkboxes a change event that will submit the form
    [].forEach.call(taxCheckboxes, el => {
        el.addEventListener('change', e => {
            submitFormOfTheOption(e.target);
        })
    })
});
